<template>
  <div class="sys-role">
    <ToolBar
      @search="search"
      @add="add"
      @dropMenuClick="dropMenuClick"
      :placeholder="'输入角色名称搜索'"
      @filter="filterFields"
      :searchArr="fields"
    ></ToolBar>
    <div class="table-content">
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="getRoleList"
        @actionClick="handlerActionClick"
        :scroll="{ x: 1300, y: `calc(100vh - ${300 + 'px'})` }"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
    <RoleModal
      :visible="visible"
      :id="id"
      @ok="handleClickOk"
      @updateList="updateList"
      :title='title'
      :rows='rows'
    ></RoleModal>
    <DistributionRole
      :visible="distributionVisible"
      @ok="distributionClose"
      :rows='rows'
    ></DistributionRole>
  </div>
</template>

<script>
import { slotOpt, fields } from './config'
import mixinsBackStack from '@/views/Back/mixins'
import ToolBar from '../../components/toolBar/index.vue'
import Table from '@/views/Back/components/table/index.vue'
import AModal from '@/views/Back/components/AModal'
import RoleModal from './components/RoleModal.vue'
import DistributionRole from './components/DistributionRole'
import { getRole, deleteRole } from '@/api/role'
export default {
  data () {
    return {
      id: null,
      visible: false,
      fields,
      slotOpt,
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      tableValue: [],
      distributionVisible: false,
      roleName: '',
      title:'新增',
      rows: {}
    }
  },
  mixins: [mixinsBackStack],
  components: { ToolBar, Table, AModal, RoleModal, DistributionRole },
  mounted () {
    this.getRoleList()
  },
  methods: {
    // 请求前的参数收集
    handlerBeforeRequestParams () {
      const { pagination } = this.$refs.table
      console.log(pagination);
      const { pageSize, pageNum } = pagination
      
      const params = {
        roleName: this.roleName,
        pageNum,
        pageSize
      }
      return params
    },
    async getRoleList () {
      const params = this.handlerBeforeRequestParams()
      let res = await getRole(params)
      
      this.tableValue = res.rows
      this.tableValue.forEach((item) => {
        item.key = item.roleId
        item.status = String(item.status)
        if (item.status === '0') {
          item.statusStr = '正常'
        } else {
          item.statusStr = '停用'
        }
      })
      console.log(this.tableValue);
      this.customOtherOpt.pagination.total = res.total
      
    },
    //处理子组件返回的参数
    search (val) {
      this.roleName = val
      this.$refs.table.pagination.pageNum = 1
      this.$refs.table.pagination.current = 1
      this.getRoleList()
    },
    handleClickOk () {
      this.id = null
      this.visible = false
    },
    add () {
      this.visible = true
      this.title = '新增'
    },
    edit (rows) {
      this.visible = true
      this.title = '编辑'
      this.rows = rows
    },
    // 单独删除
    async singleDelete (row) {
      let that = this
      this.$confirm({
        title: '是否删除改角色?',
        content: '',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        async onOk () {
          let res = await deleteRole(row.roleId)
          if (res.code === 200) {
            that.$message.success('删除成功!')
            that.getRoleList()
          } else {
            that.$message.warning(res.msg)
          }
        },
        onCancel () {
          
        },
      });

    },
    dropMenuClick () { },
    divider (rows) {
      this.distributionVisible = true
      this.rows = rows
    },
    distributionClose () {
      this.distributionVisible = false
    },
    updateList () {
      this.getRoleList()
    },
    filterFields({v, i}) {
      this.$set(this.fields[i], "isShow", v)  
    },
  }
}
</script>

<style>
</style>